// AUTO-GENERATED by scripts/generate-build-info.js. DO NOT EDIT BY HAND.
// Regenerated on every `yarn start` / `yarn build`.
export const BUILD_INFO = {
  hash: "nogit",
  time: "2026-10-27T03:02:04.822Z",
  deployId: "",
  uiVersion: "v3.1",
};
